import { getAppType } from '../appMethods/methods';
// 判断iPhonex
export var isNewIphone = function () {
    // iPhone X、iPhone XS
    var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) &&
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 375 &&
        window.screen.height === 812;
    // iPhone XS Max
    var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) &&
        window.devicePixelRatio &&
        window.devicePixelRatio === 3 &&
        window.screen.width === 414 &&
        window.screen.height === 896;
    // iPhone XR
    var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) &&
        window.devicePixelRatio &&
        window.devicePixelRatio === 2 &&
        window.screen.width === 414 &&
        window.screen.height === 896;
    if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
        return true;
    }
    return false;
};
// 去除空格
// eslint-disable-next-line no-extend-native
String.prototype.trim = function () {
    return this.replace(/(^\s*)|(\s*$)/g, '');
};
// 根据当前页面域名返回相应的域名
export var getDomainName = function () {
    if (typeof window === 'undefined') {
        return '';
    }
    var hostname = window.location.hostname;
    var domainName = '';
    if (window.location.protocol == 'file:' ||
        /\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}/g.test(hostname) ||
        hostname.indexOf('-tests') != -1 ||
        hostname.indexOf('.dev') != -1) {
        // 测试环境
        domainName = '-tests';
    }
    else if (hostname.indexOf('-box') != -1) {
        domainName = '-box';
    }
    return domainName;
};
/** 获取cookie  */
export var getCookie = function (name, cookies) {
    var cookieData = cookies;
    if (typeof cookieData === 'undefined' && typeof document === 'undefined') {
        return '';
    }
    else if (typeof cookieData === 'undefined') {
        cookieData = document.cookie;
    }
    var cookieArr = cookieData.split(';');
    for (var i = 0; i < cookieArr.length; i++) {
        var cookiePair = cookieArr[i].split('=');
        var nameEQ = cookiePair[0].trim();
        var value = cookiePair[1] ? cookiePair[1].trim() : '';
        if (nameEQ === name) {
            return value;
        }
    }
    return '';
};
/** 设置cookie */
export var setCookie = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.name, name = _c === void 0 ? '' : _c, _d = _b.value, value = _d === void 0 ? '' : _d, _e = _b.domain, domain = _e === void 0 ? document.domain : _e, _f = _b.expiredays, expiredays = _f === void 0 ? 1 : _f, _g = _b.path, path = _g === void 0 ? '/' : _g;
    // cookie有效期以天为单位
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + expiredays);
    // 临时改成小时
    // exdate.setHours(exdate.getHours()+expiredays);
    document.cookie = name + "=" + escape(value) + ";expires=" + exdate.toUTCString() + ";domain=" + domain + ";path=" + path;
};
// 清除指定cookie
export var removeCookie = function (name) {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() - 1);
    document.cookie = name + "=" + escape('') + ";expires=" + exdate.toUTCString() + ";domain=" + document.domain + ";path=/";
};
/** 动态加载js文件 **/
export var loadScript = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.url, url = _c === void 0 ? '' : _c, _d = _b.id, id = _d === void 0 ? '' : _d, _e = _b.charset, charset = _e === void 0 ? '' : _e;
    if (!window.loadScriptCache) {
        window.loadScriptCache = [];
    }
    return new Promise(function (resolve, reject) {
        if (typeof url == 'undefined' || !url) {
            reject();
        }
        if (window.loadScriptCache.indexOf(url) > -1) {
            resolve();
            return;
        }
        else {
            window.loadScriptCache.push(url);
        }
        var s = document.createElement('script');
        s.type = 'text/javascript';
        if (id) {
            s.id = id;
        }
        if (charset) {
            s.charset = charset;
        }
        else if (url.indexOf('static.xgo-img.com.cn') > -1) {
            s.charset = 'gbk';
        }
        // @ts-ignore
        if (s.readyState) {
            // @ts-ignore
            s.onreadystatechange = function () {
                // @ts-ignore
                if (s.readyState == 'loaded' || s.readyState == 'complete') {
                    // @ts-ignore
                    s.onreadystatechange = null;
                    resolve();
                }
            };
        }
        else {
            s.onload = function () {
                resolve();
            };
        }
        s.src = url;
        document.getElementsByTagName('head')[0].appendChild(s);
    });
};
export var loadJsArr = function (jsArr, isOrder) {
    if (isOrder === void 0) { isOrder = false; }
    // 动态加载多个js文件
    /*
    isOrder 多个js是并行加载还是顺序加载 默认false 并行加载， true顺序加载
    */
    var count = 0, successNum = 0;
    return new Promise(function (resolve, reject) {
        if (typeof jsArr == 'string') {
            loadScript({ url: jsArr }).then(function () {
                resolve();
            }, function () {
                reject();
            });
        }
        else if (Object.prototype.toString.call(jsArr) == '[object Array]') {
            count = jsArr.length;
            if (!isOrder) {
                // 并行加载
                var promiseAll = [];
                for (var i = 0; i < count; i++) {
                    promiseAll.push(loadScript({ url: jsArr[i] }));
                }
                Promise.all(promiseAll).then(function () {
                    resolve();
                });
            }
            else {
                orderAddJs(jsArr[successNum]);
            }
        }
        else {
            reject();
        }
        function orderAddJs(url) {
            // 顺序加载js
            if (successNum < count) {
                loadScript({ url: url }).then(function () {
                    successNum++;
                    orderAddJs(jsArr[successNum]);
                }, function () {
                    reject();
                });
            }
            else {
                resolve();
            }
        }
    });
};
/** 动态加载js源码 **/
export var loadJsCode = function (code) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    try {
        // for Chrome Firefox Opera Safari
        script.appendChild(document.createTextNode(code));
    }
    catch (ex) {
        // for IE
        script.text = code;
    }
    var body = document.getElementsByTagName('body')[0];
    body.appendChild(script);
};
/** 动态添加样式表，以<style></style>方式添加到header 样式会立即生效 **/
export var loadCssCode = function (code) {
    var style = document.createElement('style');
    style.type = 'text/css';
    // @ts-ignore
    style.rel = 'stylesheet';
    try {
        // for Chrome Firefox Opera Safari
        style.appendChild(document.createTextNode(code));
    }
    catch (ex) {
        // for IE
        // @ts-ignore
        style.styleSheet.cssText = code;
    }
    var head = document.getElementsByTagName('head')[0];
    head.appendChild(style);
};
/** array 需要排序的数组
             key 按哪个key值排序
             sortType desc 降序排列 asc升序
    **/
export var arraySort = function (array, key, sortType) {
    if (sortType === void 0) { sortType = 'asc'; }
    function rank(prop, sortType) {
        return function (obj1, obj2) {
            var val1;
            var val2;
            if (prop == '' || typeof prop == 'undefined') {
                val1 = obj1;
                val2 = obj2;
            }
            else {
                val1 = obj1[prop];
                val2 = obj2[prop];
            }
            if (!isNaN(Number(val1)) && !isNaN(Number(val2))) {
                val1 = Number(val1);
                val2 = Number(val2);
            }
            if (val1 < val2) {
                // 降序排列
                return sortType == 'desc' ? 1 : -1;
            }
            else if (val1 > val2) {
                return sortType == 'desc' ? -1 : 1;
            }
            else {
                return 0;
            }
        };
    }
    return array.sort(rank(key, sortType));
};
/** 对象的key进行排序**/
export var objKeySort = function (obj) {
    var newkey = Object.keys(obj).sort(), // 先用Object内置类的keys方法获取要排序对象的属性名，再利用Array原型上的sort方法对获取的属性名进行排序，newkey是一个数组
    newObj = {}; // 创建一个新的对象，用于存放排好序的键值对
    for (var i = 0; i < newkey.length; i++) {
        // 遍历newkey数组
        newObj[newkey[i]] = obj[newkey[i]]; // 向新创建的对象中按照排好的顺序依次增加键值对
    }
    return newObj; // 返回排好序的新对象
};
/** 对数组进行分组，返回一个新的数组，arr为原数组 n为几个一组**/
export var grounpArray = function (arr, n) {
    if (n === void 0) { n = 10; }
    // @ts-ignore
    arr = arr.slice(); // 深拷贝
    var re = [], page = Math.ceil(arr.length / n);
    for (var i = 0; i < page; i++) {
        re.push(arr.splice(0, n));
    }
    return re;
};
/**
    根据字节数截取字符串功能
    返回值：
    {len:str所占字节数,cutOutStr:根据maxNum截取的字符串,ellipsisStr:如果超出maxNum长度则增加...,originStr:原字符串}
    **/
export var getByteLen = function (val, maxNum) {
    if (maxNum === void 0) { maxNum = 10; }
    var len = 0, cutOutStr = '', ellipsisStr = '';
    maxNum = maxNum ? maxNum : val.length;
    for (var i = 0; i < val.length; i++) {
        if (val.substring(i, i + 1) != undefined) {
            if (val.substring(i, i + 1).match(/[^\x00-\xff]/gi) != null) {
                // 全角
                len = len + 2;
            }
            else {
                len = len + 1;
            }
            if (len <= maxNum) {
                cutOutStr = cutOutStr + val.substring(i, i + 1);
            }
        }
    }
    if (len > maxNum) {
        ellipsisStr = cutOutStr + '...';
    }
    else {
        ellipsisStr = cutOutStr;
    }
    return {
        len: len,
        cutOutStr: cutOutStr,
        ellipsisStr: ellipsisStr,
        originStr: val,
    };
};
/** 浮点数加法 **/
export var accAdd = function (arg1, arg2) {
    var r1, r2, m, c;
    try {
        r1 = arg1.toString().split('.')[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    c = Math.abs(r1 - r2);
    m = Math.pow(10, Math.max(r1, r2));
    if (c > 0) {
        var cm = Math.pow(10, c);
        if (r1 > r2) {
            arg1 = Number(arg1.toString().replace('.', ''));
            arg2 = Number(arg2.toString().replace('.', '')) * cm;
        }
        else {
            arg1 = Number(arg1.toString().replace('.', '')) * cm;
            arg2 = Number(arg2.toString().replace('.', ''));
        }
    }
    else {
        arg1 = Number(arg1.toString().replace('.', ''));
        arg2 = Number(arg2.toString().replace('.', ''));
    }
    return (arg1 + arg2) / m;
};
/** 浮点数减法 **/
export var accSub = function (arg1, arg2) {
    var r1, r2, m, n;
    try {
        r1 = arg1.toString().split('.')[1].length;
    }
    catch (e) {
        r1 = 0;
    }
    try {
        r2 = arg2.toString().split('.')[1].length;
    }
    catch (e) {
        r2 = 0;
    }
    m = Math.pow(10, Math.max(r1, r2)); // last modify by deeka //动态控制精度长度
    n = r1 >= r2 ? r1 : r2;
    return parseFloat(((arg1 * m - arg2 * m) / m).toFixed(n));
};
/** 获取滚动条当前的位置 **/
export var getScrollTop = function (el) {
    var scrollTop = 0;
    if (typeof el == 'undefined' || el == document) {
        if (document.documentElement && document.documentElement.scrollTop) {
            scrollTop = document.documentElement.scrollTop;
        }
        else if (document.body) {
            scrollTop = document.body.scrollTop;
        }
    }
    else {
        scrollTop = el.scrollTop;
    }
    return scrollTop;
};
/** 获取当前可是范围的高度 **/
export var getClientHeight = function (el) {
    var clientHeight = 0;
    if (typeof el == 'undefined' || el == document) {
        if (document.body.clientHeight && document.documentElement.clientHeight) {
            clientHeight = Math.min(document.body.clientHeight, document.documentElement.clientHeight);
        }
        else {
            clientHeight = Math.max(document.body.clientHeight, document.documentElement.clientHeight);
        }
        clientHeight = Math.max(clientHeight, window.innerHeight);
    }
    else {
        clientHeight = el.clientHeight;
    }
    return clientHeight;
};
/** 获取文档完整的高度 **/
export var getScrollHeight = function (el) {
    var scrollHeight = 0;
    if (typeof el == 'undefined' || el == document) {
        scrollHeight = Math.max(document.body.scrollHeight, document.documentElement.scrollHeight);
    }
    else {
        scrollHeight = el.scrollHeight;
    }
    return scrollHeight;
};
export var getStyle = function (dom, attr) {
    return dom.currentStyle
        ? dom.currentStyle[attr]
        : // @ts-ignore
            getComputedStyle(dom, false)[attr];
};
/** 获取事件对象 **/
export var getEvent = function (event) {
    return event ? event : window.event;
};
/** 获取调用对象 **/
export var getTarget = function (event) {
    var ev = getEvent(event);
    if (!ev) {
        return false;
    }
    else {
        // @ts-ignore
        return ev.currentTarget || ev.target || ev.srcElement;
    }
};
/** 绑定事件 **/
export var addHandler = function (element, type, handler) {
    if (element.addEventListener) {
        // DOM2级事件处理程序 火狐
        element.addEventListener(type, handler, false);
    }
    else if (element.attachEvent) {
        // ie
        element.attachEvent('on' + type, handler);
    }
    else {
        // DOM0
        element['on' + type] = handler;
    }
};
/** 解绑事件 **/
export var removeHandler = function (element, type, handler) {
    if (element.removeEventListener) {
        element.removeEventListener(type, handler, false);
    }
    else if (element.detachEvent) {
        element.detachEvent('on' + type, handler);
    }
    else {
        element['on' + type] = null;
    }
};
/** 绑定事件 只触发一次 */
export var once = function (dom, type, callback) {
    function handle(e) {
        callback(e);
        dom.removeEventListener(type, handle);
    }
    dom.addEventListener(type, handle);
};
export var isDom = function (obj) {
    return typeof HTMLElement === 'object'
        ? obj instanceof HTMLElement
        : obj &&
            typeof obj === 'object' &&
            obj.nodeType === 1 &&
            typeof obj.nodeName === 'string';
};
/**
 * dom自执行click
 * @param {string|HTMLElement} dom  自执行click  不传默认是body
 */
export var autoClick = function (dom) {
    dom =
        typeof dom == 'undefined' ? document.getElementsByTagName('body')[0] : dom;
    if (!isDom(dom)) {
        dom = document.getElementById(dom);
        if (!isDom(dom)) {
            console.log('is not dom');
            return false;
        }
    }
    if (document.all) {
        // IE
        dom && dom.click();
    }
    else {
        // 其它浏览器
        var e = document.createEvent('MouseEvents');
        e.initEvent('click', true, true);
        dom && dom.dispatchEvent(e);
    }
};
/** dom 滑动加载更多**/
export var scrollLoadMore = function (wrap, callbackFun, space) {
    if (space === void 0) { space = 50; }
    // 滑动加载更多
    if (typeof wrap == 'undefined' || typeof callbackFun != 'function') {
        return false;
    }
    addHandler(wrap, 'scroll', function () {
        if (getScrollHeight(wrap) - space <=
            getClientHeight(wrap) + getScrollTop(wrap)) {
            callbackFun();
        }
    });
    // return new Promise((resolve,reject)=>{
    //     addHandler(wrap,'scroll',()=>{
    //         resolve()
    //         return new Promise((resolve,reject)=>{
    //             if(getScrollHeight(wrap)-50<=getClientHeight(wrap)+getScrollTop(wrap)){
    //                 console.log(333)
    //                 resolve();
    //             }
    //         })
    //     })
    // })
};
/**
 * getParentIdTag - 获取dom节点指定id的父节点
 *
 * @param  { HTMLElement } startTag 初始dom节点
 * @param  { String } parentId 指定父节点ID
 * @return { HTMLElement } 如果存在指定ID的父节点则返回父节点，否则返回null
 */
export var getParentIdTag = function (startTag, parentId) {
    var _a, _b, _c;
    // 传入标签是否是DOM对象
    if (!(startTag instanceof HTMLElement)) {
        return console.error('receive only HTMLElement');
    }
    if (typeof parentId == 'undefined') {
        return console.error('缺少第二个父节点ID');
    }
    // 父级标签是否是body,是着停止返回集合,反之继续
    // @ts-ignore
    if ('null' != ((_a = startTag.parentElement) === null || _a === void 0 ? void 0 : _a.nodeName) &&
        'HTML' != ((_b = startTag.parentElement) === null || _b === void 0 ? void 0 : _b.nodeName)) {
        // @ts-ignore
        if (((_c = startTag.parentElement) === null || _c === void 0 ? void 0 : _c.id) == parentId) {
            return startTag.parentElement;
        }
        // 再上一层寻找
        return getParentIdTag(startTag.parentElement, parentId);
    }
    else {
        return null;
    }
};
/**
 * 在元素obj的范围内，node元素的父级的标签是否是 parentTag
 * @param {htmlElement} obj  父级元素
 * @param {string} parentTag  标签名
 * @param {htmlElement} node  目标元素
 *
 * @return {htmlElement}  如果obj元素下node元素父级元素中标签名是parentTag,则返回parentTag的dom对象
 */
export var isTagChild = function (obj, parentTag, node) {
    while (node) {
        if (node == obj) {
            break;
        }
        if (node.tagName.toLowerCase() == parentTag) {
            return node;
        }
        node = node.parentNode;
    }
    return false;
};
/**
 * 判断node是否为parent的子元素 node == parent 也会返回true
 * @param {htmlElement} parent  父元素
 * @param {htmlElement} node    子元素
 *
 * @return {boolean}   node是parent的子元素/node == parent 返回true  否则返回false
 */
export var contains = function (parent, node) {
    if (parent.compareDocumentPosition) {
        // ff
        var _flag = parent.compareDocumentPosition(node);
        return !!(_flag == 20 || _flag == 0);
    }
    else if (parent.contains) {
        // ie
        return parent.contains(node);
    }
};
/**
 * 为动态dom元素绑定事件
 * @param {htmlElement} obj 已存在的父级dom元素
 * @param {string} sTagName 待绑定的标签名
 * @param {string} sEv      待绑定的事件
 * @param {function} fn     回调函数
 */
export var live = function (obj, sTagName, sEv, fn) {
    function _fn(ev) {
        var oEvent = ev || event;
        var oTarget = oEvent.target || oEvent.srcElement;
        // target在 obj范围内，并且事件名相同
        if (oEvent.type == sEv && contains(obj, oTarget)) {
            // target的标签名符合预期，或者target的外层有符合预期(但不能超过obj)
            var curTarget = isTagChild(obj, sTagName, oTarget);
            if (curTarget) {
                // @ts-ignore
                fn(curTarget, oEvent);
            }
        }
    }
    if (obj.attachEvent) {
        obj.attachEvent('on' + sEv, _fn);
    }
    else {
        obj.addEventListener(sEv, _fn, false);
    }
};
/**
 * 为指定的dom元素绑定事件
 * @param obj 指定的父级dom元素 如果监听整个页面下的dom的事件直接写document
 * @param sDomCn dom的类名
 * @param sEv 触发的事件名称
 * @param fn 要触发的事件
 */
export var liveDom = function (obj, sDomCn, sEv, fn) {
    function _fn(ev) {
        var oEvent = ev || event;
        var oTarget = oEvent.target || oEvent.srcElement;
        var domCn = oTarget.getAttribute('class') === sDomCn || false;
        if (!domCn) {
            return;
        }
        if (oEvent.type === sEv && contains(obj, oTarget)) {
            // @ts-ignore
            fn(oTarget, oEvent);
        }
    }
    if (obj.attachEvent) {
        obj.attachEvent('on' + sEv, _fn);
    }
    else {
        obj.addEventListener(sEv, _fn, false);
    }
};
/**
 * gotoTop - 置顶
 */
export var gotoTop = function () {
    if (document.documentElement && document.documentElement.scrollTop) {
        document.documentElement.scrollTop = 0;
    }
    else if (document.body) {
        document.body.scrollTop = 0;
    }
};
/** scrollTo 滚动到指定位置*/
export var scrollToPos = function (x, y) {
    if (x === void 0) { x = 0; }
    if (y === void 0) { y = 0; }
    if (!window.scrollTo) {
        // @ts-ignore
        window.scrollTo = function (x, y) {
            // @ts-ignore
            window.pageXOffset = x;
            // @ts-ignore
            window.pageYOffset = y;
        };
    }
    window.scrollTo(x, y);
};
/**
 * 图片加载完成后回调
 */
export var loadImg = function (_a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.imgs, imgs = _c === void 0 ? [] : _c, _d = _b.overtime, overtime = _d === void 0 ? 8000 : _d, 
    // eslint-disable-next-line no-empty-function
    _e = _b.endFn, 
    // eslint-disable-next-line no-empty-function
    endFn = _e === void 0 ? function () { } : _e;
    var count = 0, n = imgs.length, loadTimer = null, loadover = 0, img;
    if (!n) {
        endFn && endFn();
        return;
    }
    imgs.map(function (item) {
        img = new Image();
        img.src = item;
        img.onerror = img.onload = function () {
            if (loadover == 1) {
                return;
            }
            count++;
            if (count === n) {
                clearTimeout(loadTimer);
                endFn && endFn();
            }
            this.onerror = this.onload = null;
        };
    });
    loadTimer = setTimeout(function () {
        loadover = 1;
        endFn && endFn();
        loadTimer = null;
    }, overtime);
};
// 生成随机数a-b 包含a和b
export var random = function (lower, upper) {
    return Math.floor(Math.random() * (upper - lower + 1)) + lower;
};
/*
 生成永不重复的随机数，随机数生成规则
 根据时间戳+4位随机字母产生随机数，存入sessionStorage的key中，判断ajaxRandom中是否有重复的，如果有则继续生成
 * @key [string] 存入sessionStorage的key名，默认ajaxRandom
*/
export var getRandom = function (key) {
    if (key === void 0) { key = 'ajaxRandom'; }
    if (typeof window == 'undefined') {
        return '';
    }
    var randomList = sessionStorage.getItem(key) == null
        ? []
        : sessionStorage.getItem(key).split(','), randomStr = '';
    do {
        randomStr = new Date().getTime() + getRandomLetter();
    } while (randomList.join(',').indexOf(randomStr) != -1);
    randomList.push(randomStr);
    sessionStorage.setItem('ajaxRandom', randomList.join(','));
    return randomStr;
};
/**
 * 生成随机num位字符，默认生成4位字符
 */
export var getRandomLetter = function (num) {
    if (num === void 0) { num = 4; }
    var result = [];
    for (var i = 0; i < num; i++) {
        var ranNum = Math.ceil(Math.random() * 25); // 生成一个0到25的数字
        // 大写字母'A'的ASCII是65,A~Z的ASCII码就是65 + 0~25;然后调用String.fromCharCode()传入ASCII值返回相应的字符并push进数组里
        result.push(String.fromCharCode(65 + ranNum));
    }
    return result.join('');
};
/**
 * 价格处理
 * returnType=1标识非数字格式时返回暂无价格,否则返回空
 */
// @ts-ignore
export var priceHandle = function (_a) {
    var _b = _a === void 0 ? {} : _a, price = _b.price, _c = _b.unit, unit = _c === void 0 ? '万' : _c, _d = _b.returnType, returnType = _d === void 0 ? 1 : _d;
    if ((Number.isNaN(parseFloat(price)) || price == 0) && returnType == 1) {
        // 返回暂无价格
        return '暂无价格';
    }
    if ((Number.isNaN(parseFloat(price)) || price == 0) && returnType != 1) {
        // 返回暂无价格
        return '';
    }
    if (!Number.isNaN(parseFloat(price))) {
        return price + unit;
    }
};
/**
 * 监听滚动事件，滚动结束后执行handler
 */
export var scrollEndHandler = function (
// eslint-disable-next-line no-empty-function
handler, _a) {
    if (handler === void 0) { handler = function () { }; }
    var _b = _a === void 0 ? {} : _a, _c = _b.el, el = _c === void 0 ? window : _c, _d = _b.time, time = _d === void 0 ? 300 : _d;
    var scrollTimer = null, scrollTop_p = 0;
    var isScrollEnd = function () {
        if (getScrollTop(el) == scrollTop_p) {
            handler();
        }
    };
    addHandler(el, 'scroll', function () {
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(isScrollEnd, time);
        scrollTop_p = getScrollTop(el);
    });
};
/**
 * 格式化数据，最多保留两位小数
 */
export var formatNum = function (num) {
    var regexp = /([0-9]+)(\.*)([0-9]{0,2})/g;
    var strs = regexp.exec(num);
    if (strs) {
        var str = strs[1] + strs[2] + strs[3];
        if (parseFloat(str) == 0 || strs[3] == '') {
            return str;
        }
        return parseFloat(str);
    }
};
/**
 * 返回当前的平台信息
 * @returns pc | m | app
 */
export var getCurPlatform = function () {
    var platform = '';
    if (typeof window !== 'undefined') {
        if (getAppType() != 'browser') {
            platform = 'app';
        }
        else if (navigator.userAgent.match(/AppleWebKit.*Mobile.*/)) {
            platform = 'm';
        }
        else {
            platform = 'pc';
        }
    }
    return platform;
};
// 去掉https、http
export var removeProtocol = function (str) {
    if (typeof str != 'string') {
        return str;
    }
    var reg = /^https?:/;
    var str2 = str.replace(reg, '');
    return str2;
};
/**
 * getHiddenProp()
 * 通过这个函数判断浏览器是否支持window.visibilitychange事件
 */
function getHiddenProp() {
    var prefixes = ['webkit', 'moz', 'ms', 'o'];
    // 如果hidden 属性是原生支持的，我们就直接返回
    if ('hidden' in document) {
        return 'hidden';
    }
    // 其他的情况就循环现有的浏览器前缀，拼接我们所需要的属性
    for (var i = 0; i < prefixes.length; i++) {
        // 如果当前的拼接的前缀在 document对象中存在 返回即可
        if (prefixes[i] + 'Hidden' in document) {
            return prefixes[i] + 'Hidden';
        }
    }
    // 其他的情况 直接返回null
    return null;
}
/**
 * getVisibilityState()
 * 获取当前页面状态
 * @returns visible/hidden
 */
function getVisibilityState() {
    var prefixes = ['webkit', 'moz', 'ms', 'o'];
    if ('visibilityState' in document) {
        return 'visibilityState';
    }
    for (var i = 0; i < prefixes.length; i++) {
        if (prefixes[i] + 'VisibilityState' in document) {
            return prefixes[i] + 'VisibilityState';
        }
    }
    // 找不到返回 null
    return null;
}
/**
 * getPageStatus()
 * 获取当前页面的可见性
 * @param cb 回调函数 页面状态发生改变会调用此函数，并通过参数传递给回调函数页面状态，页面状态分为三种
 * visible:页面处于可见状态
 * hidden：页面处于隐藏到后台状态
 * unsupport:不支持获取页面的状态
 */
export var getPageStatus = function (cb) {
    if (getHiddenProp()) {
        // 有些浏览器也需要对这个事件加前缀以便识别。
        var evtname = getHiddenProp().replace(/[H|h]idden/, '') + 'visibilitychange';
        document.addEventListener(evtname, function () {
            cb(document[getVisibilityState()]);
        }, false);
    }
    else {
        // 浏览器不支持判断页面是否在活动状态
        cb('unsupport');
    }
};
// 是不是低版本安卓 <=andriod 6.0
export var isLowerAndroid = function () {
    if (typeof navigator == "undefined") {
        return false;
    }
    if (/android/i.test(navigator.userAgent)) {
        var match = /android\s([\w.]+)/.exec(navigator.userAgent.toLowerCase());
        var versionFirst = match ? match[1] : "10.0.0";
        var versionMatch = versionFirst.split('.')[0];
        if (parseInt(versionMatch) <= 6) {
            return true;
        }
        return false;
    }
    return false;
};
